import { Box, Icon, Typography } from '@mui/material'
import AdxButton from 'components/custom/AdxButton'
import React from 'react'
import { useLocation, useNavigate } from 'react-router-dom'

const ManageHeader = ({ headerTitle, handleUpdate, saveLoading, saveError }) => {
  const navigate = useNavigate()
  const { state } = useLocation()
  return (
    <Box
      sx={{
        width: '100%',
        height: 75,
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: 'white.main',
        borderBottom: '1px solid',
        borderBottomColor: 'gray-line.main',
        position: 'sticky',
        top: 0,
        zIndex: 999,
      }}
      px={'40px'}
    >
      <Typography variant="h4" fontWeight="bold">
        {headerTitle}
      </Typography>
      <Box display="flex" flexDirection="row" alignItems="center" gap={2}>
        <Typography color="error.main">{saveError?.data?.message}</Typography>

        <AdxButton
          variant={'contained'}
          sx={{ width: 135 }}
          onClick={() => handleUpdate()}
          disabled={saveLoading ? true : false}
        >
          {saveLoading ? 'Saving...' : 'Save'}
        </AdxButton>
        <Icon
          onClick={() =>
            navigate(`/app/appraisal-cycle/details/${state.id}`, { state: { ...state } })
          }
          sx={{ fontSize: 25, cursor: 'pointer' }}
        >
          close
        </Icon>
      </Box>
    </Box>
  )
}

export default ManageHeader
